import { Component } from '@angular/core';
import { BaseDefaultListFilterComponent } from 'yt-ng-framework';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';


@Component({
    selector: 'filter-with-zaposlen',
    templateUrl: './filter-with-zaposlen.component.html'
})
export class FilterWithZaposlenComponent
 extends BaseDefaultListFilterComponent {
    
    constructor(protected datePipe: DatePipe
    ){
        super(datePipe);
    }

    selectedZaposleni: string = 'Samo zaposleni';

    ngOnInit(){
        this.filterFormGroup = new FormGroup({
            Zaposlen: new FormControl(true)
        })
        this.onChange();
    }

    onChange():void {
        this.filterFormGroup.valueChanges.subscribe(val => {
            if (val.Zaposlen == false)
                this.selectedZaposleni="Svi";
            else
                this.selectedZaposleni="Samo zaposleni";
        })
    }

    
      SetFilterDescription(){
        super.SetFilterDescription();
        this.FilterDescription = this.selectedZaposleni;
    }
}